import { render, staticRenderFns } from "./CompareTableSitecore.vue?vue&type=template&id=7412ddb4"
import script from "./CompareTableSitecore.vue?vue&type=script&lang=js"
export * from "./CompareTableSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports